import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

export type DismissButtonProps = {
  onClose: () => void;
};
// NOTE MIGRATION
export function DismissButton({ onClose }: DismissButtonProps) {
  const { t } = useTranslation('common');
  return (
    <Button variant='text' size='medium' onClick={onClose}>
      {t('errors.form.toast.dismiss')}
    </Button>
  );
}
